import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as PlantActions from '../../actions/master-data/plant.actions';

@Injectable()
export class PlantEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {
   
  }
  loadPlants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantActions.loadPlants),
      mergeMap(() =>
        this.masterDataService.getAllPlants().pipe(
          map((plants) => PlantActions.loadPlantsSuccess({ plants })),
          catchError((error) => of(PlantActions.loadPlantsFailure({ error })))
        )
      )
    )
  );

  addPlant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantActions.addPlant),
      mergeMap(({ plant }) =>
        this.masterDataService.addNewPlant(plant).pipe(
          mergeMap((saved) => [
            PlantActions.addPlantSuccess({
              plant: saved,
              message: 'Plant created successfully'
            }),
            PlantActions.loadPlants()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the plant';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PlantActions.loadPlantsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updatePlant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantActions.updatePlant),
      mergeMap(({ plant }) =>
        this.masterDataService.updatePlant(plant).pipe(
          mergeMap((saved) => [
            PlantActions.updatePlantSuccess({
              plant: saved,
              message: 'Plant updated successfully'
            }),
            PlantActions.loadPlants()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while updating the plant';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PlantActions.loadPlantsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );  

  deletePlant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantActions.deletePlant),
      mergeMap(({ id }) =>
        this.masterDataService.deletePlant(id).pipe(
          mergeMap((saved) => [
            PlantActions.deletePlantSuccess({
              message: 'Plant deleted successfully'
            }),
            PlantActions.loadPlants()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while deleting the plant';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(PlantActions.loadPlantsFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}